module.exports = __webpack_public_path__ + "@/assets/img/work_step_1.5f65b9c8.png";